import React, { useState, useEffect } from 'react';
import { useTypedTranslation } from '@app/hooks';
import { Link, Typography, Grid } from '@material-ui/core';
import { vaultImportPasswordsService } from '@app/services';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import { ButtonSubmit, PasslyTextField } from '@app/components';
import { store, genericErrorToast, PASSWORD_IMPORTER_HELP_URL } from '@app/helpers';
import { IUserData } from '@app/models';
import { handleSetSnackbar } from '@app/store/actions/snackbar.actions';
import { useDispatch } from 'react-redux';
import { OpenInNew } from '@material-ui/icons';

const GettingStartedComponent = () => {
    const { translation } = useTypedTranslation();
    const dispatch = useDispatch();

    const currentUser: IUserData = store.getState().signIn.currentUser;

    const [email, setEmail] = useState<string>('');
    const [submitValid, setSubmitValid] = useState<boolean>(true);
    const [emailValid, setEmailValid] = useState<boolean>(true);
    const [passwordImporterUrl, setPasswordImporterUrl] = useState<string>('');
    const [submitting, setSubmitting] = useState<boolean>(false);

    useEffect(() => {
        setEmail(currentUser.email);
        vaultImportPasswordsService.getPasswordImporterUrl(genericErrorToast, handleSuccessPasswordImporterUrl);
    }, []);

    const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        setEmailValid(event.target.validity.valid);
        setEmail(value);
    };

    const sendEmail = () => {
        if (!emailValid) {
            setSubmitValid(false);
            return;
        }
        else {
            setSubmitValid(true);
            setSubmitting(true);
        }

        // send email API
        vaultImportPasswordsService.sendImportEmail(email, handleError, handleSendEmailSuccess);
    };

    const handleSuccessPasswordImporterUrl = (response: any) => {
        setPasswordImporterUrl(response.data.Url);
    };

    const handleSendEmailSuccess = () => {
        const snackbarMessage: string = translation('SENT_ENCRYPTION_KEY');

        dispatch(handleSetSnackbar({ show: true, message: snackbarMessage, severity: 'success' }));

        setSubmitting(false);
    };

    const handleError = (response: any) => {
        genericErrorToast(response);

        setSubmitting(false);
    };

    return (
        <>
            <div className='passwordImportChoice passwordImportChoice__gettingStarted'>
                <Typography align='center' variant='h1'>{translation('PASSWORD_IMPORT_GETTING_STARTED_HEADER')}</Typography>
                    <Typography variant='h3'>{translation('PASSWORD_IMPORT_GETTING_STARTED_STEP1')}</Typography>

                    <Grid container>
                        <Grid container item xs={3}>
                            <PasslyTextField
                                fullWidth
                                autoFocus
                                autoComplete='off'
                                id='email-input'
                                name='Email'
                                onChange={handleEmailChange}
                                error={!submitValid}
                                helperText={submitValid ? '' : translation('INVALID_EMAIL')}
                                value={email}
                                type={'email'}
                                placeholder={translation('ENTER_EMAIL')}
                                inputProps={{ maxLength: 100 }}
                                hintText={translation('PASSWORD_IMPORT_GETTING_STARTED_EMAIL_INSTR')}
                            />
                        </Grid>
                        <Grid container item xs={1}>
                            <ButtonSubmit
                                className='passwordImportChoice__sendButton'
                                onClick={sendEmail}
                                id='sendEmailButton'
                                isDisabled={submitting}
                                isLoad={submitting}
                                buttonText={translation('SEND')}>
                            </ButtonSubmit>
                        </Grid>
                    </Grid>

                    <Typography variant='h3'>{translation('PASSWORD_IMPORT_GETTING_STARTED_STEP2')}</Typography>
                    <Grid container>
                        <Grid container item xs={3}>
                            <Link href={passwordImporterUrl}>
                                {translation('PASSWORD_IMPORT_DOWNLOAD_ENCRYPTOR')}
                                <SystemUpdateAltIcon />
                            </Link>
                        </Grid>

                        <Grid container item xs={3}>
                            <Link href={PASSWORD_IMPORTER_HELP_URL} target='_blank'>
                                {translation('PASSWORD_IMPORT_VIEW_GUIDE')}
                                <OpenInNew color='primary' />
                            </Link>
                        </Grid>
                    </Grid>

                    <Typography variant='h3'>{translation('PASSWORD_IMPORT_GETTING_STARTED_STEP3')}</Typography>
            </div>
        </>
    );
};

export default GettingStartedComponent;